import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  id: number;
  created_at: number;
  updated_at: number;
  currency_code: string;
  note: string;
  decline_note: string;
  start_date: string;
  end_date: string;
  payment_system: string;
  payout: string;
  status: string;
  pdf: string;
  manual: boolean;
  affiliate: {
    id: number;
    name: string;
  };
  payment_details: string | null;
}
